import {Aux, isNullEmptyOrWhitespace, IsNullOrUndefined} from "../../constants";
import moment from "moment";
import React from "react";
import PropTypes from 'prop-types';

export const PickupNoteSummary = (props) => {
    let {pickup} = props;
    
    let cancel = null;
    let pickupNote = null;
    let pickupNotes = null;
    let pickupTanks = null;
    let dropOffTanks = null;

    if(!isNullEmptyOrWhitespace(pickup.cancelReason)){
        let css = pickup.pickupStatusCode === 'CAN' ? 'font-weight-bold text-danger' : 'font-weight-bold text-info';
        let text = pickup.pickupStatusCode === 'CAN' ? 'cancelled' : 'note';

        cancel = (<div className="row">
            <div className="col-md-12">
                <span className={css}>{pickup.clientCompanyName} {text}: </span>
                <span>{pickup.cancelReason}</span>
            </div>
        </div>);
    }

    if(!isNullEmptyOrWhitespace(pickup.pickupNote)){
        let css = 'font-weight-bold text-info';
        let text = 'note';

        pickupNote = (<div className="row">
            <div className="col-md-12">
                <span className={css}>{pickup.clientCompanyName} {text}: </span>
                <span>{pickup.pickupNote}</span>
            </div>
        </div>);
    }
    
    pickupNotes = pickup.notes.map(note => (<div className={"row"} key={note.id}>
        <div className={"col-12"}>
            <a href={`#note_detail_${note.id}`}
               aria-expanded="false"
               aria-controls={`note_detail_${note.id}`}
               data-toggle="collapse"><span>{pickup.clientCompanyName}:</span> {note.noteText}</a></div>

        <div className="collapse col-12" id={`note_detail_${note.id}`}>
            <div className={"row"}>
                <div className={"col-12"}>{note.updatedBy}</div>
            </div>
            <div className={"row"}>
                <div className={"col-12"}>{moment(note.createdDate).format('DD/MM/YYYY LT')}</div>
            </div>
        </div>
    </div>));    
    
    pickupTanks = pickup.pickupTanks.filter(x => x.requiresPickup).map(tank => (<div className={"row"} key={tank.tankID}>
        <div className="col-md-12">
            <span className={`font-weight-bold text-${tank.isPickedUp ? 'success' : 'warning'}`}>{pickup.clientCompanyName}: Pickup tank #{tank.tankID}</span>            
        </div>
    </div>));
    dropOffTanks = pickup.pickupTanks.filter(x => x.requiresDropOff).map(tank => (<div className={"row"} key={tank.tankID}>
        <div className="col-md-12">
            <span className={`font-weight-bold text-${tank.driverEstimatedLitresPickedUp > 0 ? 'success' : 'warning'}`}>{pickup.clientCompanyName}: Drop-off tank #{tank.tankID}</span>
        </div>
    </div>));
    
    let dropOffCount = pickup.tankRequests ? pickup.tankRequests.filter(x => IsNullOrUndefined(x.actionCompleteDate) && x.tankActionType === 2).length : 0;
    let dropOffText = dropOffCount > 0 ? `Drop-off ${dropOffCount} tank${dropOffCount > 1 ? 's' : ''}` : 'Tank Drop-off';
    let pickupHasDropOff = (dropOffCount > 0 || pickup.hasAnyTankDropOffs) && <div className={"row"}>
        <div className="col-md-12">
            <span className={`font-weight-bold text-${pickup.pickupStatusCode === 'COM' ? 'success' : 'warning'}`}>{pickup.clientCompanyName}: {dropOffText}</span>
        </div>
    </div>; 

    return (<Aux key={pickup.id}>
        {cancel}
        {pickupNote}
        {pickupNotes}
        {pickupHasDropOff}
        {pickupTanks}      
        {dropOffTanks}
    </Aux>);  
};

PickupNoteSummary.propTypes = {
  pickup: PropTypes.object.isRequired,  
};